export default "__VITE_ASSET__70a34aaa__"